// Shared Base Rate warning banner for the sales document forms (quotation, proforma).
// Rendered above the save/submit actions while any line item sells below its
// master-data Base Rate, so the violation stays visible until it is fixed.

import { formatBaseRateAmount } from '@/lib/baseRate';

interface BannerViolation {
  name: string;
  baseRate: number;
  effectiveUnitRate: number;
  discountLabel: string;
}

export function BaseRateWarningBanner({ violations, documentLabel }: { violations: BannerViolation[]; documentLabel: string }) {
  if (!violations.length) return null;
  const label = documentLabel.charAt(0).toUpperCase() + documentLabel.slice(1);
  return (
    <div role="alert" className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
      <p className="font-semibold">
        {label} cannot be submitted because one or more services are below their minimum Base Rate.
      </p>
      <ul className="mt-1 list-disc pl-5 text-xs">
        {violations.map((v, i) => (
          <li key={i}>
            <span className="font-medium">{v.name}</span>: selling at ₹{formatBaseRateAmount(v.effectiveUnitRate)} after a{' '}
            {v.discountLabel} discount — minimum Base Rate is ₹{formatBaseRateAmount(v.baseRate)}.
          </li>
        ))}
      </ul>
    </div>
  );
}
